export default __webpack_public_path__ + "static/media/john.8c9caf68.png";